import CommentLayout from "app/uicomponents/macrocomponents/Comments/CommentLayout";
import { makeRequest } from "app/utils/makeRequest";
import { getSessionStore } from "app/utils/sessionStore";
import React, { useEffect, useState } from "react";

const ExperienceTab: React.FC<{ isIntReactiveRevCent?: boolean }> = ({ isIntReactiveRevCent }) => {
  const [videoUrl, setVideoUrl] = useState<string>("");
  const proposalType =
    Object.keys(getSessionStore("proposalType") || {}).length > 0
      ? getSessionStore("proposalType")
      : getSessionStore("selectedProposalRow")?.proposalType;

  useEffect(() => {
    const fetchData = async () => {
      const soliutionApi = isIntReactiveRevCent
        ? "interactiveRevCentSolution"
        : "interactiveProposalSolution";
      const creditType = isIntReactiveRevCent
        ? getSessionStore("ircSelectedCreditType") ?? "preCredit"
        : null;
      const query = creditType
        ? `proposalType=${proposalType}&creditType=${creditType}`
        : `proposalType=${proposalType}`;
      try {
        const response = await makeRequest(soliutionApi).get(query, false, true);

        setVideoUrl(response?.data?.data?.experience || "");
      } catch (error) {
        // console.error(error);
        // Handle error (e.g., show a toast message)
      }
    };

    fetchData();
  }, [isIntReactiveRevCent]);

  return (
    <CommentLayout
      commentLayoutId="interactive-proposal-solution-experience"
      className="h-screen flex flex-col items-center"
    >
      <div className="w-full max-w-6xl h-[calc(100vh-16rem)]">
        {videoUrl && (
          <div
            className="relative w-full rounded-2xl overflow-hidden bg-gray-600"
            style={{ aspectRatio: "16/8", border: "1px solid #d1d1db" }}
          >
            <video
              className="w-full h-full object-cover"
              controls
              playsInline
              controlsList="nodownload"
              aria-label="Experience video content"
            >
              <source src={videoUrl} type="video/mp4" />
              <track kind="captions" src="" label="English captions" srcLang="en" default />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
      </div>
    </CommentLayout>
  );
};

export default ExperienceTab;
